import { LoadingButton } from "@mui/lab";
import { Alert, Box, Grid,} from "@mui/material";
import PasswordInput from "components/PasswordInput";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import { changePasswordThunk } from "store/reducers/accounts";
import * as yup from "yup";

const validation = yup.object({
  old_password: yup.string().required(),
  new_password1: yup.string().required(),
  new_password2: yup.string().required(),
});

const ChangePassword = () => {
  const { loadingPassChange, successPassChange, errorPassChange } = useSelector(
    (state) => state.accounts
  );
  useEffect(() => {
    if (errorPassChange) {
      Object.keys(errorPassChange).forEach((key) => {
        console.log(key, errorPassChange[key][0]);
        formik.setFieldError(key, errorPassChange[key][0]);
      });
    }
  }, [errorPassChange]);
  const formik = useFormik({
    initialValues: {
      old_password: "",
      new_password1: "",
      new_password2: "",
    },
    validationSchema: validation,
    onSubmit: (data) => {
      dispatch(changePasswordThunk(data));
    },
    validateOnChange: false,
  });
  return (
    <Box padding={3}>
      <form onSubmit={formik.handleSubmit}>
        <Grid container columnSpacing={2} rowSpacing={0}>
          <Grid item xs={12} md={6} lg={4}>
            <PasswordInput
              label="Old password"
              variant="outlined"
              name="old_password"
              fullWidth
              sx={{ mt: 3 }}
              value={formik.values.old_password}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.old_password)}
              helperText={formik.errors.old_password}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <PasswordInput
              label="New Password"
              variant="outlined"
              name="new_password1"
              fullWidth
              sx={{ mt: 3 }}
              value={formik.values.new_password1}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.new_password1)}
              helperText={formik.errors.new_password1}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <PasswordInput
              label="Repeat password"
              variant="outlined"
              name="new_password2"
              fullWidth
              sx={{ mt: 3 }}
              value={formik.values.new_password2}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.new_password2)}
              helperText={formik.errors.new_password2}
            />
          </Grid>
        </Grid>

        {successPassChange && (
          <Alert sx={{ my: 1 }} severity="success">
            Success
          </Alert>
        )}
        {errorPassChange && (
          <Alert sx={{ my: 1 }} severity="error">
            Error occurred.{ "  "}
            {errorPassChange?.non_field_errors &&
              errorPassChange?.non_field_errors[0]}
          </Alert>
        )}
        <LoadingButton
          loading={loadingPassChange}
          variant="contained"
          type="submit"
          sx={{ paddingX: 10, marginTop: 2, width: 200 }}
        >
          Update
        </LoadingButton>
      </form>
    </Box>
  );
};

export default ChangePassword;
